import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { CompetitorSite } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { CompetitorSiteLayer } from '../../transportLayers/site/CompetitorSiteLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of price competitors.
 */

export var CompetitorSiteStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(CompetitorSiteStore, _BaseStore);

  function CompetitorSiteStore() {
    var _this;

    _classCallCheck(this, CompetitorSiteStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorSiteStore).apply(this, arguments));
    _this.name = StoreName.CompetitorSite;
    _this.competitorSiteLayer = new CompetitorSiteLayer();
    _this.list = new Map();

    _this.toggleActive = function (ids, active) {
      return _this.competitorSiteLayer.toggleActive(ids, active).then(function (competitorSites) {
        runInAction(function () {
          competitorSites.forEach(function (competitorSite) {
            if (competitorSite.id) {
              _this.list.set(competitorSite.id, competitorSite);
            }
          });
        });
        return competitorSites;
      });
    };

    return _this;
  }
  /**
   * Will fetch all data for this page
   */


  _createClass(CompetitorSiteStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.competitorSiteLayer.findAll().then(function (competitorSites) {
        runInAction(function () {
          competitorSites.forEach(function (competitorSite) {
            if (competitorSite.id) {
              _this2.list.set(competitorSite.id, competitorSite);
            }
          });
        });
        return competitorSites;
      });
    }
  }, {
    key: "getOne",
    value: function getOne(siteId) {
      var _this3 = this;

      return this.competitorSiteLayer.findOne(siteId).then(function (competitorSite) {
        runInAction(function () {
          _this3.list.set(competitorSite.id, competitorSite);
        });
        return competitorSite;
      });
    }
  }, {
    key: "update",
    value: function update(site) {
      var _this4 = this;

      return this.competitorSiteLayer.update(site).then(function (competitorSite) {
        runInAction(function () {
          _this4.list.set(competitorSite.id, competitorSite);
        });
        return competitorSite;
      });
    }
  }]);

  return CompetitorSiteStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], CompetitorSiteStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CompetitorSiteStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], CompetitorSiteStore.prototype, "getOne", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [CompetitorSite]), __metadata("design:returntype", Promise)], CompetitorSiteStore.prototype, "update", null);

__decorate([action, __metadata("design:type", Object)], CompetitorSiteStore.prototype, "toggleActive", void 0);